import React from 'react';
import IntlContext from './IntlContext';

const Time = ({ value }) => {
  return (
    <IntlContext.Consumer>{({ time }) => time(value)}</IntlContext.Consumer>
  );
};

export default Time;
